/*
Mixins based on MetadataBase
To add additional slot functionality
*/

import Component from 'vue-class-component'

import MetadataBase from './MetadataBase'

import { valIsMissing, valIsNA } from '@/utils/data'

/* Slot Names made available for use by mixins */
/* Prefixes (followed by any text) are for additional slots */
const SN_DESC = 'desc_value'
const SN_DESC_PREFIX = 'desc_value_'
const SN_NA_TEXT = 'na_text'
const SN_MISSING_TEXT = 'missing_text'
const SN_ARIA_LABEL = 'aria_label'
const SN_ARIA_LABEL_LEGEND = 'aria_label_legend'
const SN_WEBSITE = 'website'

/*
Mixin for using SN_DESC and SN_DESC_PREFIX slots
*/
@Component
export class MetadataDescMixin extends MetadataBase {
  /* Getters */

  get descValue () { return this.dispValueForSlotName(SN_DESC) }

  get hasDescSlot () { return this.hasSlotName(SN_DESC) }

  get customDescSlotData () { return this.slotDataForPrefix(SN_DESC_PREFIX) }
  get hasCustomDescSlots () { return this.customDescSlotData.length > 0 }

  // Template text for description defaults to one on description slot, or
  //  else main text.  Use customTemplateText in subclass to override
  get customTemplateText () { return undefined }
  get descTemplateText () {
    return this.customTemplateText ||
      this.displayTextForSlotName(SN_DESC) ||
      this.mainDisplayText
  }

  get descDisplayText () {
    return this.descReplaceValues(this.descTemplateText)
  }

  get descSlotNames () {
    const descSlotNames = this.customDescSlotData.map(d => d.component_slot)
    if (this.hasDescSlot) {
      descSlotNames.push(SN_DESC)
    }
    return descSlotNames
  }

  descReplaceValues (text) {
    let result = text
    this.descSlotNames.forEach(d => {
      result = result.replace(`{{${d}}}`, this.dispValueForSlotName(d))
    })
    return result
  }

  descReplaceDisplayTextForSlot (slotData) {
    return this.descReplaceValues(this.displayTextForSlot(slotData))
  }
}

/*
Mixin for using SN_NA_TEXT, SN_MISSING_TEXT slots
*/
@Component
export class MetadataFallbackTextMixin extends MetadataBase {
  /* Getters */

  get hasNASlot () { return this.hasSlotName(SN_NA_TEXT) }
  get isValueNA () { return valIsNA(this.valueForSlotName(SN_NA_TEXT)) }
  get naText () { return this.displayTextForSlotName(SN_NA_TEXT) }

  get hasMissingSlot () { return this.hasSlotName(SN_MISSING_TEXT) }
  get isValueMissing () { return valIsMissing(this.valueForSlotName(SN_MISSING_TEXT)) }
  get missingText () { return this.displayTextForSlotName(SN_MISSING_TEXT) }

  // Fallback text may be blank, so use this to check if it should be used
  get useFallbackText () {
    return this.fallbackText !== undefined
  }
  get fallbackText () {
    return (this.hasNASlot && this.isValueNA) ? this.naText
      : (this.hasMissingSlot && this.isValueMissing) ? this.missingText
        : undefined
  }
}

/*
Mixin for using SN_ARIA_LABEL and SN_ARIA_LABEL_LEGEND slot
*/
@Component
export class MetadataAriaLabelMixin extends MetadataBase {
  /* Getters */
  // Default for label is undefined to allow default behavior of reading text
  //  in the component, instead of overwriting with empty string
  get ariaLabel () { return this.hasSlotName(SN_ARIA_LABEL) ? this.displayTextForSlotName(SN_ARIA_LABEL) : undefined }
  get ariaLabelLegend () { return this.hasSlotName(SN_ARIA_LABEL_LEGEND) ? this.displayTextForSlotName(SN_ARIA_LABEL_LEGEND) : undefined }
}

/*
Mixin for using SN_WEBSITE slots
*/
@Component
export class MetadataWebsiteMixin extends MetadataBase {
  /* Getters */

  get websiteValue () { return this.hasWebsiteValue ? this.dispValueForSlotName(SN_WEBSITE) : '' }
  get websiteDispText () { return this.displayTextForSlotName(SN_WEBSITE) }
  get hasWebsiteValue () { return !valIsMissing(this.valueForSlotName(SN_WEBSITE)) }
  get hasWebsiteSlot () { return this.hasSlotName(SN_WEBSITE) }
}



// WEBPACK FOOTER //
// ./src/components/sqs/2023/tab-mods/metadata-mixin.js